import { Grid } from "@mui/material";
import DataHubTable from "./components/DataHubTable";
import { useDataHubMeterDetailsYearly } from "./hooks";
import { string, func, object } from "prop-types";
import React from "react";
import type { Dispatch, SetStateAction } from "react";

interface MeterDetailsYearlyProps {
  view: string;
  setView: Dispatch<SetStateAction<string>>;
  meteringPointId: string;
  date: any; // date object or range from NewDatePicker
  setDate: (date: any) => void;
  selectedSegment: number;
  setSelectedSegment: (segment: number) => void;
  gettext?: (key: string) => string;
}

const MeterDetailsYearly = (props: MeterDetailsYearlyProps) => {
  const {
    view,
    setView,
    meteringPointId,
    date,
    setDate,
    selectedSegment,
    setSelectedSegment,
    gettext,
  } = props;
  const { meterDetailYearly, loading } = useDataHubMeterDetailsYearly(
    meteringPointId,
    date,
  );

  return (
    <Grid>
      <DataHubTable
        title={view}
        setView={setView}
        view={view}
        rows={meterDetailYearly}
        selectededDate={date}
        segment={selectedSegment}
        getSelectedDate={(date: any) => {
          setDate(date);
        }}
        onSegmentChange={(selectedSegment: string | number) => {
          setDate(date);
          setSelectedSegment(
            typeof selectedSegment === "number" ? selectedSegment : 0,
          );
        }}
        gettext={gettext}
        loading={loading}
      />
    </Grid>
  );
};
export default MeterDetailsYearly;

MeterDetailsYearly.propTypes = {
  view: string.isRequired,
  setView: func.isRequired,
  meteringPointId: string.isRequired,
  date: object.isRequired,
  setDate: func.isRequired,
  selectedSegment: string,
  setSelectedSegment: func,
  gettext: func,
};
